<div [class]="isLoading ? 'page-loader' : 'page-loader d-none'"></div>

<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button type="button" class="close-btn" (click)="close()">
    <img src="/assets/admin/images/close-icon.svg" width="16" height="16" alt="close-icon" />
  </button>
</div>

<div class="modal-body" (scroll)="onScroll($event)">
  <div class="history-table-wrap">
    <table class="history-table">
      <thead>
        <tr>
          @if (isManualFee) {
            <th>Previous Amount</th>
            <th>Changed Amount</th>
          } @else {
            <th>Previous Date</th>
            <th>Changed Date</th>
          }
          <th>Updated At</th>
          <th>Updated By</th>
          <th>Notes</th>
        </tr>
      </thead>
      <tbody>
        @if (!isLoading && historyList.length === 0) {
          <tr>
            <td colspan="5" class="no-records">No histories found</td>
          </tr>
        }
        @for (item of historyList; track $index) {
          <tr>
            @if (isManualFee) {
              <td>{{ item.last_enabled ? (item.last_amount | currency: 'USD':'symbol') : '-' }}</td>
              <td>{{ item.new_enabled ? (item.new_amount | currency: 'USD':'symbol') : 'Off (auto)' }}</td>
            } @else {
              <td>{{ formatDate(item.last_date) }}</td>
              <td>{{ formatDate(item.new_date) }}</td>
            }
            <td>{{ formatDate(item.updated_date) }}</td>
            <td>{{ item.updated_by || '-' }}</td>
            <td class="notes">{{ item.notes || '-' }}</td>
          </tr>
        }
        @if (isLoadingMore) {
          <tr>
            <td colspan="5" class="loading-more">Loading histories...</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
